import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";

class ShowTbl extends React.Component {
  state = {};

  componentDidMount() {}

  showTablesResult() {
    var data = this.props.tbl[1];

    var lstTr = data.map((d) => (
      <Tr key={uuidv4()}>
        <Td>{d[0]}</Td>
        <Td>{d[1]}</Td>
        <Td>{d[2]}</Td>
      </Tr>
    ));

    return (
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Bytes</Th>
            <Th>Count</Th>
          </Tr>
        </Thead>
        <Tbody>{lstTr}</Tbody>
      </Table>
    );
  }

  render() {
    return <Stack>{this.showTablesResult()}</Stack>;
  }
}

export default ShowTbl;
